// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3aBOk","errors":"Errors_errors__21FQP"};